{
  "embedded.layout.title": "工单",
  "embedded.layout.openStandalone": "在完整工作台打开",
  "embedded.tickets.tabs.all": "全部工单",
  "embedded.tickets.tabs.assigned": "我跟进的",
  "embedded.tickets.tabs.participating": "我协作的",
  "embedded.connecting.title": "正在连接宿主",
  "embedded.connecting.detail": "等待宿主应用建立安全通道。",
  "embedded.waitingToken.title": "正在获取凭证",
  "embedded.waitingToken.detail": "宿主应用正在为本次会话签发访问凭证。",
  "embedded.handshakeFailed.title": "无法连接宿主应用",
  "embedded.handshakeFailed.detail": "宿主没有响应握手。请刷新宿主页面；如果仍然失败，请联系管理员检查嵌入配置。",
  "embedded.invalidConfig.title": "宿主配置无效",
  "embedded.invalidConfig.detail": "已填写宿主 Origin，但没有有效值。请联系管理员检查嵌入配置。",
  "embedded.notEmbedded.title": "本页面只能在宿主应用中打开",
  "embedded.notEmbedded.detail": "请改用完整工作台，不要直接访问该地址。",
  "embedded.sessionEnded.title": "会话已结束",
  "embedded.sessionEnded.detail": "宿主应用已退出登录。请在宿主中重新登录后再打开工单。",
  "embedded.sessionEnded.unauthorized": "凭证已不被接受。请刷新宿主页面以开始新的会话。",
  "embedded.accessDenied.title": "无权访问该对象",
  "embedded.accessDenied.detail": "你的 Tickbird 权限不覆盖这条工单。如需访问请联系 Tickbird 管理员。",
  "embedded.context.title": "业务上下文",
  "embedded.context.systemCode": "业务系统",
  "embedded.context.entityType": "对象类型",
  "embedded.context.entityId": "对象标识",
  "embedded.context.waiting": "宿主还没有传入业务上下文。",
  "embedded.context.providerPending": "关联工单暂不可用：解析该业务对象的服务端集成适配器尚未实现。",
  "embedded.ticketDetail.title": "工单",
  "embedded.ticketDetail.back": "返回关联工单",
  "embedded.newTicket.title": "新建工单",
  "embedded.newTicket.projectMissing": "宿主尚未配置工单项目，请联系管理员在嵌入配置中设置 projectCode。",
  "embedded.pagePending": "本页目前是骨架。共享的工单功能块还需要先下沉到共享 Feature 层。"
}
